// @flow

import React, { Component } from "react";

import FilterOption from "./../FilterOption/FilterOption";

type PropsType = {
	path: string,
	filterGroup: TopicListFilterGroupType,
};

type StateType = {
	isExpanded: boolean,
	canUseDOM: boolean,
};

const defaultExpandedFilterGroupIds = ["ProductType"];

export class FilterGroup extends Component<PropsType, StateType> {
	constructor(props: PropsType) {
		super(props);

		this.state = {
			isExpanded: true,
			canUseDOM: false,
		};

		this.handleTitleClick = this.handleTitleClick.bind(this);
	}

	componentDidMount() {
		this.setState({
			canUseDOM: true,
			isExpanded:
				this.getSelectedCount() > 0 ||
				defaultExpandedFilterGroupIds.includes(this.props.filterGroup.id),
		});
	}

	handleTitleClick: () => void;
	handleTitleClick() {
		this.setState((prevState) => ({
			isExpanded: !prevState.isExpanded,
		}));
	}

	getSelectedCount() {
		return this.props.filterGroup.options.filter((option) => option.isSelected)
			.length;
	}

	getOptionsToRender() {
		return this.props.filterGroup.options.filter(
			(opt) => opt.unfilteredResultCount > 0
		);
	}

	render() {
		// Text for showing the number of options selected
		const selectedCount = this.getSelectedCount();
		let numSelected = null;
		if (selectedCount > 0) {
			numSelected = (
				<div className="filter-group__count">{selectedCount} selected</div>
			);
		}

		return (
			<div className="filter-group">
				{this.state.canUseDOM ? (
					<button
						type="button"
						aria-expanded={this.state.isExpanded}
						aria-controls={`group-${this.props.filterGroup.id}`}
						className={`filter-group__heading gtm-topic-list-filter-group-${
							this.state.isExpanded ? "collapse" : "expand"
						}`}
						onClick={this.handleTitleClick}
					>
						<svg
							className={`filter-group__heading-icon ${this.state.isExpanded ? "filter-group__heading-icon--expanded" : ""}`}
							width="1em"
							height="1em"
							viewBox="0 0 512 512"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M478.152 174C478.152 184.091 474.627 192.661 467.576 199.712L281.576 385.712C274.333 392.955 265.667 396.576 255.576 396.576C245.293 396.576 236.723 392.955 229.864 385.712L43.864 199.712C36.6213 192.853 33 184.283 33 174C33 163.909 36.6213 155.243 43.864 148L65 126.576C72.424 119.525 81.0907 116 91 116C101.091 116 109.661 119.525 116.712 126.576L255.576 265.44L394.44 126.576C401.491 119.525 410.061 116 420.152 116C430.061 116 438.728 119.525 446.152 126.576L467.576 148C474.627 155.424 478.152 164.091 478.152 174Z"
								fill="black"
							/>
						</svg>
						<div id={`group-title-${this.props.filterGroup.id}`}>
							{this.props.filterGroup.title}
						</div>
						{numSelected}
					</button>
				) : (
					<h3 className="filter-group__heading">
						<div id={`group-title-${this.props.filterGroup.id}`}>
							{this.props.filterGroup.title}
						</div>
						{numSelected}
					</h3>
				)}
				<fieldset
					id={`group-${this.props.filterGroup.id}`}
					aria-hidden={!this.state.isExpanded}
					className="filter-group__options"
				>
					<legend>{this.props.filterGroup.title}</legend>
					{this.getOptionsToRender().map((opt) => (
						<FilterOption
							key={opt.id}
							groupId={this.props.filterGroup.id}
							groupName={this.props.filterGroup.title}
							path={this.props.path}
							option={opt}
						/>
					))}
				</fieldset>
			</div>
		);
	}
}

export default FilterGroup;
